import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLElement> {
  onMonitorChange = (evt: CustomEvent<HTMLInputElement>) => {
    const input = evt.target as HTMLInputElement | null;
    if (input) {
      this.dispatch("monitor", { detail: { monitor: input.value } });
    }
  };
}
